module.exports = __webpack_public_path__ + "static/media/YB5M09_2.f99446d8.jpg";